// Pricing logic for custom gelato
// Base: $40 for 3kg, +$7 per additional kg
// Each ingredient choice (except Step 2 styles) = +$5
const BASE_PRICE = 40;
const PRICE_PER_EXTRA_KG = 7;
const PRICE_PER_INGREDIENT = 5;

export function computePrice(state) {
  const items = [];
  const kg = state.quantity_kg || 3;
  const quantityCost = BASE_PRICE + Math.max(0, kg - 3) * PRICE_PER_EXTRA_KG;
  items.push({ category: "Quantity", label: `${kg} kg`, price: quantityCost });

  const categoryDefs = [
    { key: "fruits", label: "Fruit" },
    { key: "creams", label: "Cream" },
    { key: "crazy", label: "Crazy" },
    { key: "crunchy", label: "Crunchy" },
    { key: "swirls", label: "Swirl" },
    { key: "spicy", label: "Spice" },
    { key: "functional", label: "Functional" },
  ];
  for (const c of categoryDefs) {
    for (const name of state[c.key] || []) {
      items.push({ category: c.label, key: c.key, label: name, price: PRICE_PER_INGREDIENT });
    }
  }
  if (state.alcohol_type) {
    items.push({
      category: "Alcohol",
      key: "alcohol_type",
      label: `${state.alcohol_type} ${state.alcohol_percent || 0}%`,
      price: PRICE_PER_INGREDIENT,
    });
  }

  const total = items.reduce((s, i) => s + i.price, 0);
  return { items, total };
}

export const PRICING = { BASE_PRICE, PRICE_PER_EXTRA_KG, PRICE_PER_INGREDIENT };
